import * as React from "react";
import { Debug } from "vars";
import { P } from "../../apparatus/library/common";
/**
 * Component to display current state of rotation while
 * an item or collection of items is being rotated.
 * To use this component, instantiate it and update by setting state.
 */
export class RotationOverlay extends React.Component {
    constructor(props) {
        super(props);
        this.state = { pivot: P(0, 0), angle: 0 };
    }
    render() {
        if (!this.state.type)
            return null;
        if (Debug.PRESENTATION_MODE)
            return null;
        let { pivot, angle: rotation, type } = this.state;
        let labelOffsetX = 155 * Math.sin(rotation.toRadians()) - 30;
        let labelOffsetY = -135 * Math.cos(rotation.toRadians()) - 12;
        return React.createElement(React.Fragment, null,
            React.createElement("div", { id: "rotation-line", key: "guideLine", style: {
                    left: pivot.x,
                    top: pivot.y - 130,
                    transform: `rotate(${rotation}deg)`
                } }),
            type == "delta" ?
                React.createElement("div", { id: "rotation-base", key: "base_line", style: {
                        left: pivot.x,
                        top: pivot.y - 100,
                    } })
                : null,
            React.createElement("div", { id: "rotation-info", key: "rotationInfo", style: {
                    left: pivot.x + labelOffsetX,
                    top: pivot.y + labelOffsetY,
                } }, this.label()));
    }
    /** Determine the label to display based on given state. */
    label() {
        // Round the rotation to 1 decimal place.
        let rotation = Math.round(this.state.angle * 10) / 10;
        let rotationString = rotation.toFixed(1);
        switch (this.state.type) {
            case "rotation":
                return `${rotationString}°`;
            case "delta":
                return `Δ=${rotation >= 0 ? "+" : ""}${rotation}°`;
            default:
                return ""; // Should not happen
        }
    }
}
